import { useQuery } from '@tanstack/react-query'

import { getDatasets } from '@app/services/dataUploadService'

export const DATASETS_QUERY_KEY = ['datasets'] as const

export function useFetchDatasets() {
  return useQuery({
    queryKey: DATASETS_QUERY_KEY,
    queryFn: getDatasets,
    staleTime: 1000 * 60 * 30,
  })
}
